import { useState } from 'react';
import { FaRoad, FaTwitter, FaTelegram, FaPills } from 'react-icons/fa';
import { Modal } from './Modal';

const phases = [
  {
    title: "Phase 1: Community Building & Meme Dominance",
    points: [
      "Flood social media with Memes",
      "Implement Chat History",
      "Introduce Chill Points rewards system",
    ]
  },
  {
    title: "Phase 2: Platform Enhancement",
    points: [
      "Release badass Trap Song on all platforms",
      "Launch Swag Market",
      "Implement AI market predictions",
      "Host Stoner Sessions",
    ]
  },
  {
    title: "Phase 3: Advanced Features",
    points: [
      "Integrate AI token analysis",
      "Implement community governance",
      "Form strategic alliances with other memecoins"
    ]
  },
  {
    title: "Phase 4: Ultimate Evolution",
    points: [
      "Launch Skunk Nirvana",
      "New Outfits and Bling",
      "Release Music Video on Youtube"
    ]
  }
];

export function Navbar() {
  const [isRoadmapOpen, setIsRoadmapOpen] = useState(false);

  return (
    <>
      <nav className="fixed bottom-0 left-0 right-0 z-20 px-4 pb-6">
        <div className="flex flex-col items-center gap-6 w-fit sm:w-fit max-w-2xl mx-auto">
          <div className="flex flex-wrap justify-center w-fit gap-4 p-4 rounded-2xl bg-black/20 backdrop-blur-lg border border-white/10 shadow-xl">
            <a 
              href="https://x.com/SolSkunk"
              target="_blank" 
              rel="noopener noreferrer" 
              className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors text-white/90 hover:text-white"
            >
              <FaTwitter className="text-lg" />
              <span className="font-medium hidden md:inline">Twitter</span>
            </a>
            <a 
              href="https://t.me/SolSkunk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors text-white/90 hover:text-white"
            >
              <FaTelegram className="text-lg" />
              <span className="font-medium hidden md:inline">Telegram</span>
            </a>
            <a 
              href="https://pump.fun/coin/YogxeCx2moATA6XvZyLjS6Vf6YscygzTvFoCDMipump" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors text-white/90 hover:text-white"
            >
              <FaPills className="text-lg" />
              <span className="font-medium hidden md:inline">Pump</span>
            </a>
            <button
              onClick={() => setIsRoadmapOpen(true)}
              className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors text-white/90 hover:text-white"
            >
              <FaRoad className="text-lg" />
              <span className="font-medium hidden md:inline">Roadmap</span>
            </button>
          </div>
        </div>
      </nav>

      <Modal isOpen={isRoadmapOpen} onClose={() => setIsRoadmapOpen(false)}>
        <div className="
          w-[min(90vw,400px)]
          bg-black/40
          border border-white/10 
          rounded-lg overflow-hidden
          shadow-2xl 
          animate-fadeIn
        ">
          <div className="px-6 py-4 max-h-[70vh] overflow-y-auto custom-scrollbar">
            {phases.map((phase, index) => (
              <div 
                key={index} 
                className="mb-8 last:mb-0 animate-fadeIn"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <h3 className="text-white/90 font-medium mb-4 text-lg tracking-wide">
                  {phase.title}
                </h3>
                <ul className="space-y-3">
                  {phase.points.map((point, pointIndex) => (
                    <li 
                      key={pointIndex} 
                      className="
                        text-white/70 text-sm 
                        flex items-start gap-3 
                        hover:text-white/90 
                        transition-colors duration-300
                        animate-slideIn
                      "
                      style={{ animationDelay: `${(index * 50) + (pointIndex * 50)}ms` }}
                    >
                      <span className="
                        block w-1.5 h-1.5 mt-2 
                        rounded-full bg-white/70 
                        group-hover:bg-white/90
                        transition-colors duration-300
                      " />
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
} 